import { render, staticRenderFns } from "./FormaRecebimentoModal.vue?vue&type=template&id=45654f1b&scoped=true"
import script from "./FormaRecebimentoModal.vue?vue&type=script&lang=js"
export * from "./FormaRecebimentoModal.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimentoModal.vue?vue&type=style&index=0&id=45654f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45654f1b",
  null
  
)

export default component.exports